"use client";

import { useEffect } from "react";
import { GoogleAnalytics } from "@/shared";
import { KakaoInitializer } from "@/shared";
import { AppLayout } from "@/widgets";

// // css
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "@fortawesome/fontawesome-free/css/all.css";
// import "react-perfect-scrollbar/dist/css/styles.css";
// import "@/shared/admin/styles/nextjs.scss";
// import "@/app/styles/admin/style.css";

import "@/app/styles/globals.css";

export default function Layout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  useEffect(() => {
    let isMounted = true;
    const loadBootstrap = async () => {
      try {
        const bootstrap = await import("bootstrap");
        if (isMounted) {
          window.bootstrap = bootstrap;
        }
      } catch (error) {
        console.error("Error loading Bootstrap:", error);
      }
    };

    if (typeof window !== "undefined") loadBootstrap();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <GoogleAnalytics />
      <AppLayout>{children}</AppLayout>
      <KakaoInitializer />
    </>
  );
}
